import React from "react";
import { withOktaAuth } from "@okta/okta-react";
import MainFrameRetailGID from "./components/MainFrameRetailGID";
import "./RetailGID.css";
import Header from "./components/Header/Header-RetailGID";
import { retailGidGroups } from "./config";

const RetailGID = ({ authState }) => {
  if (!authState.isAuthenticated) {
    return <div>Loading...</div>;
  }

  console.log("RetailGID.js: authState", authState);

  const hasRetailGidGroup =
    authState.idToken.claims &&
    authState.idToken.claims.groups &&
    authState.idToken.claims.groups.some((groups) =>
      retailGidGroups.includes(groups)
    );

  return (
    <div>
      <Header hasRetailGidGroup={hasRetailGidGroup} />
      <MainFrameRetailGID hasRetailGidGroup={hasRetailGidGroup} />
    </div>
  );
};

export default withOktaAuth(RetailGID);
